import { create } from 'zustand';

// Define types for the cache entry and store state
interface CategoryCacheEntry {
  CategoryData?: unknown;
  filteredData?: unknown;
}

interface CategoryStoreState {
  cache: Record<string, CategoryCacheEntry>;
  currentQuery: string | null;
  isFromMinMaxFilter: boolean;
  setIsFromMinMaxFilter: (val: boolean) => void;
  storeCurrentQuery: (
    fullKey: string,
    CategoryData?: unknown,
    filteredData?: unknown
  ) => void;
  getCachedData: (query: string) => CategoryCacheEntry | null;
  clearCache: () => void;
}

const useCategoryStore = create<CategoryStoreState>((set, get) => ({
  cache: {},
  currentQuery: null,
  isFromMinMaxFilter: false,
  setIsFromMinMaxFilter: (val: boolean) => set({ isFromMinMaxFilter: val }),
  storeCurrentQuery: (
    fullKey: string,
    CategoryData?: unknown,
    filteredData?: unknown
  ) =>
    set((state: CategoryStoreState) => {
      const existingEntry = state.cache[fullKey] || {};

      const newEntry: CategoryCacheEntry = {
        ...existingEntry,
        ...(CategoryData !== undefined ? { CategoryData } : {}),
        ...(filteredData !== undefined ? { filteredData } : {}),
      };

      return {
        currentQuery: fullKey,
        cache: {
          ...state.cache,
          [fullKey]: newEntry,
        },
      };
    }),

  // Retrieve cache for a query key, or null if none
  getCachedData: (query: string) => {
    const cache = get().cache;
    return cache[query] || null;
  },

  // Clear the cache (in-memory only)
  clearCache: () => {
    set({ cache: {}, currentQuery: null });
  },
}));

export default useCategoryStore;
